import Vue from 'vue'
import Vuex from 'vuex'
import article from './modules/article'
import associatedPress from './modules/associatedPress'
import appRedirect from './modules/appRedirect'
import appSettings from './modules/appSettings'
import auth from './modules/auth'
import betHubPages from './modules/betHubPages'
import betHubSeo from './modules/betHubSeo'
import bookmaker from './modules/bookmaker'
import bookMakerBestPromo from './modules/bookMakerBestPromo'
import bookMakerWelcomePromo from './modules/bookMakerWelcomePromo'
import bookMakerPromo from './modules/bookMakerPromo'
import guide from './modules/guide'
import tag from './modules/tag'
import team from './modules/team'
import newsLetter from './modules/newsLetter'
import editor from './modules/editor'
import publisher from './modules/publisher'
import pageSettings from './modules/pageSettings'
import usStates from './modules/usStates'
import user from './modules/user'
import sportBettingArticles from './modules/sportBettingArticles'
import SBPoll from './modules/SBPoll'
import SBCategory from './modules/SBCategory'
import bestBookSettings from './modules/bestBookSettings'
import VueClipboard from 'vue-clipboard2'
import banner from './modules/banner'
import inArticlePromo from './modules/inArticlePromo'
import ftpLiveGame from './modules/ftpLiveGame'
import podcastItem from './modules/podcastItem'
import bestOddsPageSettings from './modules/bestOddsPageSettings'
import futuresPageSettings from './modules/futuresPageSettings'
import pageBuilder from './modules/pageBuilder'
import googleFonts from './modules/googleFonts'
import bestBooksMenuSettings from './modules/bestBooksMenuSettings'
import inContentConversionBanner from './modules/inContentConversionBanner'
import author from './modules/author'
import bestProp from './modules/bestProp'
import bestBet from './modules/bestBet'

VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    article,
    associatedPress,
    appRedirect,
    appSettings,
    auth,
    betHubPages,
    betHubSeo,
    bookmaker,
    bookMakerBestPromo,
    bookMakerWelcomePromo,
    bookMakerPromo,
    guide,
    tag,
    team,
    newsLetter,
    publisher,
    pageSettings,
    usStates,
    user,
    sportBettingArticles,
    SBPoll,
    SBCategory,
    bestBookSettings,
    banner,
    inArticlePromo,
    ftpLiveGame,
    podcastItem,
    bestOddsPageSettings,
    futuresPageSettings,
    pageBuilder,
    googleFonts,
    bestBooksMenuSettings,
    inContentConversionBanner,
    author,
    bestProp,
    bestBet,
    editor
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer (state, value) {
      state.controls.showDrawer = value
    }
  }
})
